import { Box, BoxType, Point, Polygon } from '@hakimo-ui/hakimo/types';

function getTagTextFromBoxType(type?: BoxType) {
  switch (type) {
    case BoxType.PERSON:
      return 'Person';
    case BoxType.LOITERING_PERSON:
      return 'Loitering Person';
    case BoxType.PERSON_WITH_WEAPON:
      return 'Weapon';
    case BoxType.VEHICLE:
      return 'Vehicle';
    case BoxType.FACE:
      return 'Face';
    default:
      return '';
  }
}

function getColorFromBoxType(type?: BoxType): string {
  switch (type) {
    case BoxType.VEHICLE:
      return 'cyan';
    case BoxType.FACE:
      return 'red';
    case BoxType.PERSON_WITH_WEAPON:
      return 'red';
    default:
      return 'yellow';
  }
}

export const getVideoPolygons = (boxes: Box[]): Polygon[] => {
  return boxes.map((box) => {
    const [left, top, width, height] = box.coords;
    const points: Point[] = [
      [left, top],
      [left + width, top],
      [left + width, top + height],
      [left, top + height],
    ];
    const polygon: Polygon = {
      color: getColorFromBoxType(box.type),
      pointSize: 'small',
      closed: true,
      points,
      tag: getTagTextFromBoxType(box.type),
    };
    return polygon;
  });
};
